import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Search from '../../../components/header/Search';

import {
  searchClear,
  searchRequest,
} from '@xanadu/ui-shared/modules/search/actions';

const mapDispatchToProps = {
  searchRequest,
  searchCleared: searchClear
};

function mapStateToProps(state) {
  return {
    product: state.getIn(['application', 'product']),
    isLoggedIn: state.getIn(['user', 'isLoggedIn']),
    results: state.getIn(['search', 'searchResults']),
    loading: state.getIn(['search', 'loading']),
    tags: state.getIn(['navigation', 'tags']),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Search));
